var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid scoped-visible-container" },
    [
      _vm.header != ""
        ? _c(
            "div",
            {
              staticClass: "row",
              attrs: { id: "emailtemplates--validation-header" }
            },
            [_c("h3", [_vm._v(_vm._s(_vm.header))])]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("transition", { attrs: { type: "fade" } }, [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading,
                  expression: "!loading"
                }
              ],
              staticClass: "scoped-contains-email-validation",
              domProps: {
                innerHTML: _vm._s(_vm.stripScripts(_vm.validationContent))
              }
            })
          ]),
          _c(
            "transition",
            { attrs: { type: "fade" } },
            [
              _c("loader-widget", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                attrs: { id: "validate-template-loader" }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }